import { IconTrash } from '../../componentes/Icons';

const PendingGrid = ({
    pendingRegistrations,
    handleActivateRegistration,
    handleDeleteRegistration,
    saving,
    BILLING_CYCLES
}) => {
    return (
        <section className="pending-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '20px' }}>
            {pendingRegistrations.length === 0 ? (
                <div style={{ gridColumn: '1 / -1', padding: '100px', textAlign: 'center', opacity: 0.3 }}>
                    <p>Nenhuma solicitação pendente no momento.</p>
                </div>
            ) : (
                pendingRegistrations.map(reg => (
                    <div key={reg.id} className="tenant-card pending" style={{ borderLeft: '4px solid var(--gold-primary)' }}>
                        <div className="tenant-card-header">
                            <div className="tenant-main-info">
                                <h4 style={{ color: 'var(--gold-primary)' }}>{reg.shopName}</h4>
                                <span className="tenant-id-badge">Sugestão ID: {reg.shopSlug}</span>
                            </div>
                            <span className="tenant-status-pill" style={{ background: 'rgba(218, 165, 32, 0.1)', color: 'var(--gold-primary)' }}>
                                Aguardando Pagamento
                            </span>
                        </div>
                        <div className="tenant-details">
                            <div className="detail-item">
                                <span className="detail-label">Proprietário</span>
                                <span>{reg.ownerName}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Email</span>
                                <span>{reg.ownerEmail}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Plano / Ciclo</span>
                                <span style={{ fontWeight: 800, color: 'var(--gold-primary)', textTransform: 'uppercase' }}>
                                    {reg.plan} / {BILLING_CYCLES.find(c => c.months === (reg.billingCycle || 1))?.name || 'Mensal'}
                                </span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Data do Registro</span>
                                <span>{new Date(reg.createdAt).toLocaleDateString('pt-BR')}</span>
                            </div>
                        </div>
                        <div className="tenant-actions" style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                            <button
                                className="modal-btn primary"
                                style={{ flex: 1, padding: '12px' }}
                                onClick={() => handleActivateRegistration(reg)}
                                disabled={saving}
                            >
                                {saving ? 'ATIVANDO...' : 'ATIVAR E CRIAR LOJA'}
                            </button>
                            <button
                                className="action-btn delete"
                                style={{ height: '48px', width: '48px' }}
                                onClick={() => handleDeleteRegistration(reg.id)}
                            >
                                <IconTrash />
                            </button>
                        </div>
                    </div>
                ))
            )}
        </section>
    );
};

export default PendingGrid;
